import request from '../../../../../../logic/utils/request';
import { attachQuestion } from './transitions';

const questionUrl = (questionId) => `/server/api/qcquestion/${questionId}/`;

export const sortByPosition = (answers = []) => [...answers]
  .sort((a, b) => a.position - b.position);

export const getChains = (answer) => answer?.additional_questions || [];

export const countChains = (answer) => getChains(answer).length;

export const hasAnyChains = (answers = []) => answers.some((a) => countChains(a) > 0);

// Сервер затирает непереданные поля ответа значениями по умолчанию
// (answertxt -> "", type -> 0), поэтому ответ всегда передаётся целиком.
const answerFields = (answer, position) => ({
  type: answer.type === undefined || answer.type === null ? 3 : answer.type,
  answertxt: answer.answertxt || '',
  answerint: Number(answer.answerint) || 0,
  weight: Number(answer.weight) || 0,
  correct: Boolean(answer.correct),
  position,
});

// Позиция берётся из самого ответа, а не из индекса массива: точечно шлём
// только изменённые ответы, и нумеровать их заново было бы неверно.
const toExistingAnswer = (answer) => ({
  id: answer.id,
  ...answerFields(answer, Number(answer.position) || 0),
});

const toNewAnswer = (answer, position) => answerFields(answer, position);

// Точечное обновление: все ответы с id, сервер трогает только переданные.
// Годится для правки текста, веса и порядка, но не для добавления и удаления.
// Передавать стоит минимум ответов: если хоть один из них уже использован в
// анкетировании, сервер отклонит запрос целиком (код 15).
export const updateAnswersInPlace = async (questionId, answers) => {
  const res = await request(questionUrl(questionId), 'update', {
    correctAnswers: answers.map(toExistingAnswer),
  });
  return sortByPosition(res?.data?.answers || []);
};

// Полная замена: все ответы без id. Сервер помечает прежние deleted и создаёт
// новые строки с новыми id, из-за чего молча теряются все привязки доп.
// вопросов на этом вопросе — поэтому после замены их пересоздаём.
export const replaceAnswersWithChains = async (questionId, nextAnswers) => {
  const res = await request(questionUrl(questionId), 'update', {
    correctAnswers: nextAnswers.map(toNewAnswer),
  });
  const created = sortByPosition(res?.data?.answers || []);

  const restored = [];
  const failed = [];

  for (let i = 0; i < nextAnswers.length; i++) {
    const chains = getChains(nextAnswers[i]);
    const createdAnswer = created[i];

    for (let j = 0; j < chains.length; j++) {
      if (!createdAnswer) break;
      try {
        // Последовательно: операции над переходами защищены общим mutex.
        // eslint-disable-next-line no-await-in-loop
        const transition = await attachQuestion(createdAnswer.id, chains[j].id, j);
        restored.push({ ...chains[j], __transitionId: transition?.id ?? null });
      } catch (e) {
        failed.push({
          answertxt: createdAnswer.answertxt,
          questiontext: chains[j].questiontext,
        });
      }
    }
  }

  return { answers: created, restored, failed };
};

// Список привязок, которые пострадают от полной замены — для предупреждения.
export const describeChains = (answers = []) => answers
  .filter((answer) => countChains(answer) > 0)
  .map((answer) => ({
    answertxt: answer.answertxt,
    questions: getChains(answer).map((q) => q.questiontext),
  }));
